import { clearAdditionalFormData, getAdditionalFormData } from "./globals";
import { sendMail, validateRecaptcha } from "./tools";

// Callable functions
export function successMessagePopup(message?: string) {
  let container = $(".popup__success");
  let popupBg = $(".popup-bg");
  let messageText = container.find(".popup__success-container-content-text");
  if (message) {
    messageText.text(message)
  }
  container.addClass("popup__success-active");
  setTimeout(() => {
    container.removeClass("popup__success-active");
    popupBg.removeClass("popup-bg-active");
    window.scrollLock.enablePageScroll();
  }, 2000);
}

export function errorMessagePopup(message?: string) {
  let container = $(".popup__error");
  let popupBg = $(".popup-bg");

  let messageText = container.find(".popup__error-container-content-text");
  if (message) {
    messageText.text(message)
  }

  container.addClass("popup__error-active");
  // setTimeout(() => {
  // container.removeClass("popup__error-active");
  // popupBg.removeClass("popup-bg-active");
  // window.scrollLock.enablePageScroll();
  // }, 2000);
}

/**
 * Call popup
 */
export function callPopup() {
  let popup = $(".popup");
  let popupBg = $(".popup-bg");

  popup.toggleClass("popup-active");
  window.scrollLock.disablePageScroll();
  popupBg.toggleClass("popup-bg-active");
}

// Init fun
export function initPopups() {
  togglePopup();
  sendFormPopup();
  closeSuccessPopup();
  closeErrorPopup();
}

function togglePopup() {
  let button = $(".callPopup");
  let popup = $(".popup");
  let popupBg = $(".popup-bg");
  let close = $(".popup__close");
  // TODO: Add event listener here

  button.on("click", function () {
    popup.toggleClass("popup-active");
    window.scrollLock.disablePageScroll();
    popupBg.toggleClass("popup-bg-active");
  });
  close.on("click", function () {
    popup.removeClass("popup-active");
    window.scrollLock.enablePageScroll();
    popupBg.removeClass("popup-bg-active");
  });
  popupBg.on("click", function () {
    window.scrollLock.enablePageScroll();
    popup.removeClass("popup-active");
    popupBg.removeClass("popup-bg-active");
  });
}

function sendFormPopup() {
  let form = $(".popup__form");
  let formElement = form.get(0) as HTMLFormElement;
  let popup = $(".popup");
  if (formElement) {
    form.submit(async (e) => {
      e.preventDefault();
      let formElement = e.currentTarget as HTMLFormElement;
      // Get form data
      let data = getAdditionalFormData();

      let token = await validateRecaptcha(formElement.querySelector(".captcha-container"))
      if (!token) {
        errorMessagePopup("Капча не загружена или неверна");
        return;
      }

      let contactInfo = new FormData(formElement as HTMLFormElement);
      // add token
      contactInfo.set("token", token);

      // If we have data, add it
      if (data) {
        data.forEach((value: any, index: any) => {
          contactInfo.append(index, value);
        });
      }

      sendMail(contactInfo)
        .then((response) => {
          if (response.ok) {
            popup.removeClass("popup-active");
            // Reset form data
            clearAdditionalFormData();
            return (
              successMessagePopup() /*,
              yaCounter********.reachGoal('****', () => {})*/,
              formElement.reset()
            );
          } else {
            popup.removeClass("popup-active");
            return errorMessagePopup("Отправить сообщение не удалось, свяжитесь с нами через чат"), formElement.reset();
          }
        })
        .catch(() => {
          popup.removeClass("popup-active");
          return errorMessagePopup("Отправить сообщение не удалось, свяжитесь с нами через чат"), formElement.reset();
        });
    });
  }
}

function closeSuccessPopup() {
  let popup = $(".popup__success");
  let close = $(".popup__success-button, .popup__success-close");
  let messageText = popup.find(".popup__success-container-content-text");

  let popupBg = $(".popup-bg");
  close.on("click", function () {
    popup.removeClass("popup__success-active");
    popupBg.removeClass("popup-bg-active");
    window.scrollLock.enablePageScroll();
    // Reset popup text
    messageText.text("Мы свяжемся с Вами в ближайшее время")
  });
}

function closeErrorPopup() {
  let popup = $(".popup__error");
  let close = $(".popup__error-button, .popup__error-close");
  let popupBg = $(".popup-bg");

  let messageText = popup.find(".popup__error-container-content-text");

  close.on("click", function () {
    popup.removeClass("popup__error-active");
    popupBg.removeClass("popup-bg-active");
    window.scrollLock.enablePageScroll();
    // reset error popup text
    messageText.text("Что-то пошло не так")
  });
}
